import decode from "jwt-decode";
import API from "./index";
const tokenField = "tokenWeb";

export async function login({ username, password }) {
  try {
    const { user, token } = await API.auth.login({ username, password });

    if (user && token) {
      setToken(token);

      return Promise.resolve(user);
    } else {
      return Promise.reject("Неправильные: Имя пользователя/Пароль");
    }
  } catch (err) {
    return Promise.reject(err);
  }
}

export function loggedIn() {
  // Checks if there is a saved token and it's still valid
  const token = getToken(); // GEtting token from localstorage
  return !!token && !isTokenExpired(token); // handwaiving here
}

function isTokenExpired(token) {
  try {
    const decoded = decode(token);
    if (decoded.exp < Date.now() / 1000) {
      // Checking if token is expired. N
      return true;
    } else return false;
  } catch (err) {
    return false;
  }
}

export function setToken(token) {
  // Saves user token to localStorage
  localStorage.setItem(tokenField, token);
}

export function getToken() {
  // Retrieves the user token from localStorage
  return localStorage.getItem(tokenField);
}

export function logout() {
  // Clear user token and profile data from localStorage
  localStorage.removeItem(tokenField);
}

export function getProfile() {
  // Using jwt-decode npm package to decode the token
  return decode(getToken());
}
